import React, { useState } from "react";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { Box } from "../../../../../../shared/Box/Box";
import { history } from "../../../../../../history";
import { SETTINGS_ROUTES } from "../../../../../../consts/routes";
import { Actions } from "./shared/Actions";
import { CrossIcon } from "../../../../../../assets/Icons/CrossIcon";
import styles from "./styles.module.scss";
import { Modal } from "../../../../../../shared/Modal/Modal";
import { ButtonMobileMenu } from "./shared/ButtonMobileMenu";
import { useContext } from "../../context";

export const Header = () => {
  const { tSettings: t } = useAppTranslation.Settings({
    keyPrefix: "survey",
  });

  const { isEditMode } = useContext();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <Box className={styles.root}>
      <div className={styles.left}>
        <button onClick={() => history.push(SETTINGS_ROUTES.surveys())}>
          <CrossIcon width="18px" />
        </button>
        <h4 className={styles.title}>
          {isEditMode ? t("title.edit") : t("title.create")}
        </h4>
      </div>
      <ButtonMobileMenu
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      />
      <Actions className={styles.desktopActions} />
      {isMobileMenuOpen && (
        <Modal
          isOpen
          size="small"
          onClose={() => setIsMobileMenuOpen(false)}
          header={<Modal.Title>{t("actions_menu.title")}</Modal.Title>}
        >
          <Actions mobile />
        </Modal>
      )}
    </Box>
  );
};
